var state = {
    all: [],
    showUpsell: false,
};
var getters = {
    allItems: function (state) { return state.all; },
    showUpsell: function (state) { return state.showUpsell; },
};
var actions = {
    setItems: function (_a, items) {
        var commit = _a.commit;
        commit('setItems', items);
    },
    setShowUpsellOn: function (_a) {
        var commit = _a.commit;
        commit('setShowUpsell', true);
    },
    setShowUpsellOff: function (_a) {
        var commit = _a.commit;
        commit('setShowUpsell', false);
    },
    setShowUpsell: function (_a, showUpsell) {
        var commit = _a.commit;
        commit('setShowUpsell', showUpsell);
    },
};
var mutations = {
    setItems: function (state, items) {
        state.all = items;
    },
    setShowUpsell: function (state, showUpsell) {
        state.showUpsell = showUpsell;
    },
    addItem: function (state, item) {
        state.all.push(item);
    },
    clearItems: function (state) {
        state.all = [];
    }
};
export default {
    namespaced: true,
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
};



//////////////////
// WEBPACK FOOTER
// ./src/stores/modules/upsell.store.ts
// module id = null
// module chunks = 